

exports.__esModule = true;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

var _index2 = require('xo-models/src/user/index');

require('xo-ui-components/src/accessibility/directive');

var _factory = require('./factory');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoCurrencyConversionDirective', {
    tag: 'xo-currency-conversion',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        doneFn: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()
            };
        },
        conversion: function conversion(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                var fundingOptionId = _this.checkoutInputData.funding_option_id;

                if (!fundingOptionId || fundingOptionId === models.checkoutSession.plan.id) {
                    return models.checkoutSession.plan.conversion || {};
                }

                return models.checkoutSession.fundingOptions.action('getConversion', {
                    data: {
                        planId: fundingOptionId
                    },
                    success: function success(result) {
                        return result;
                    }
                });
            });
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            var _this2 = this;

            var checkoutSession = this.models.checkoutSession;


            function mapConversionType(type) {
                return type ? 'PAYPAL' : 'VENDOR';
            }

            var selectedConversionType = mapConversionType(this.models.ppconversion);
            var planConversionType = mapConversionType(this.conversion.paypal);

            if (selectedConversionType === planConversionType) {
                this.props.doneFn();
                _logger.$logger.info('currency_conversion', {
                    from: 'CURRENCY_CONVERSION',
                    to: 'cancel_currency_conversion'
                });
                return;
            }

            _logger.$logger.info('currency_conversion', {
                from: 'CURRENCY_CONVERSION',
                to: 'process_currency_conversion',
                conversion_selected: selectedConversionType
            });

            var payload = {
                conversionType: selectedConversionType,
                planId: this.checkoutInputData.funding_option_id || checkoutSession.plan.id
            };

            if (payload.planId) {
                return checkoutSession.fundingOptions.action('updateConversion', {
                    data: payload,
                    success: function success(result) {
                        if (payload.planId !== checkoutSession.plan.id) {
                            // don't need to reload checkoutSession after updating the conversion of the backup funding option
                            return _this2.props.doneFn(result);
                        }
                        return checkoutSession.reload({
                            success: function success() {
                                var conversion = checkoutSession.plan.conversion || {};

                                if (!_this2.models.ppconversion) {
                                    if (conversion.paypal) {
                                        _logger.$logger.info('currency_conversion_not_honored', {
                                            type: _this2.models.ppconversion,
                                            from: conversion.from,
                                            to: conversion.to,
                                            changeable: conversion.changeable
                                        });
                                    } else {
                                        checkoutSession.plan.conversion = checkoutSession.plan.conversion || {
                                            changeable: true,
                                            paypal: false
                                        };

                                        if (!checkoutSession.plan.conversion.from || !checkoutSession.plan.conversion.to) {
                                            _logger.$logger.info('currency_conversion_rate_missing');
                                        }
                                    }
                                }
                                return _this2.props.doneFn(result);
                            }
                        });
                    }
                });
            }
        }
    },
    lifecycle: {
        enter: function enter() {
            this.checkoutInputData = _index2.$CheckoutInputDataModel.instance(this.props.token);
        },
        populate: function populate() {
            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                cart = _models.cart;


            this.models.ppconversion = !!this.conversion.paypal;
            this.paypalConversionTotal = _factory.$CurrencyConversionFactory.getPayPalConversionTotal(checkoutSession, this.conversion);
            this.cardIssuerData = _factory.$CurrencyConversionFactory.getCardIssuerData(checkoutSession, this.conversion, cart);
            this.toTargetCurrency = this.conversion.to_amount_forex + ' ' + this.conversion.to_code;
            this.fromUnitCurrency = '1 ' + this.conversion.from_code;

            _logger.$logger.info('currency_conversion', {
                from: 'CURRENCY_CONVERSION',
                to: 'prepare_currency_conversion',
                conversion_type: this.conversion.paypal ? 'PAYPAL' : 'VENDOR',
                is_conversion_shown: 1
            });
        }
    }
});


_squid.$Component;

_logger.$logger;

_index.$CheckoutSessionModel;

_index.$CheckoutCartModel;

_index2.$CheckoutInputDataModel;

_factory.$CurrencyConversionFactory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/currency-conversion/directive.js
// module id = ../node_modules/xo-wallet-components/src/currency-conversion/directive.js
// module chunks = 0